var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 55,
  height: 33,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1 16.149h52.74M53.74 16.149 38.593 31.298M53.74 16.149 38.593 1",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round"
})));
export { SvgArrowRight as ReactComponent };
export default __webpack_public_path__ + "/assets/4d92f9dde72d275c0e152c6f7f740578.svg";